import { useEffect } from 'react';
import AuthService from '../services/AuthService';
import { useLocation } from 'react-router-dom';

const Login = (props) => {   
    	const location = useLocation();
	useEffect( () => {
        	let parms = new URLSearchParams(location.search);
        	let code = parms.get("code");
		 AuthService.verify(code);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    return (
        <></>

    )
}

export default Login;
